//@flow
export const UPLOAD_SUCCESS: string = 'uploadSuccess';
export const UPLOAD_FAIL: string = 'uploadFail';
export const UPLOAD_PROGRESS: string = 'updateUploadProgress';
export const UPLOAD_PAUSE: string = 'uploadPause';
export const UPLOAD_RESUME: string = 'uploadContinue';
export const UPLOAD_CANCEL: string = 'uploadCancel';
export const UPLOAD_FILE_NAME: string = 'uploadFileName';
export const UPLOAD_CLEAR_STATUS: string = 'uploadClearStatus';
export const UPLOAD_MESSAGE: string = 'uploadMessage';

export const PHOTOS_TYPE: string = 'photos';
export const VIDEO_TYPE: string = 'video';
export const SHP_TYPE: string = 'shp';
export const ORTO_TYPE: string = 'orto';
export const DTM_TYPE: string = 'dtm';
export const DRONE_TYPE: string = 'drone';
export const MODEL_TYPE: string = 'model';
export const RESOURCE_TYPE: string = 'attachment';


// WEBPACK FOOTER //
// ./src/types/upload.jsx